<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold"
        >“At least a few people could lead confidently.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This reflects <span class="font-bold"
        >depth of trust, readiness, and leadership development.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      You’ve built a system where leadership isn’t centralized - it’s
      distributed and trusted.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      This is Fast Attack culture at its best - rotating command, shared
      responsibility, mission-first clarity.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >Do those people know they’re seen as ready?</span
      >
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Call it out publicly - and give them more lead roles now, before they’re
      needed later.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“Maybe one or two - if they had help.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      You’re developing leaders - but the readiness is uneven.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      There’s potential, but not yet certainty.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      A sub crew where only a few know the full mission can’t respond fast in an
      emergency. Everyone has to be trained for the bridge.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Pick one rising leader and give them a 30-day shadow assignment.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Tell them: <span class="italic"
        >“If I disappeared tomorrow, I’d want you running point.”
      </span> Then build to that.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold">“They’d keep it afloat, but not lead it.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This reveals <span class="font-bold"
        >operational coverage, but not strategic trust.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      The team can maintain - but not drive forward.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      In elite teams, maintenance isn’t enough - you need movement. Otherwise
      you stall under pressure.
    </p>

    <p class="mt-6 text-lg/8 text-gray-700 font-bold">Level-Up Opportunity</p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >What’s keeping this team from leading - clarity, confidence, or
        control?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Then start pushing authority to the edge, one decision at a time.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold">“No one. It would stall without me.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a red alert - you are the single point of failure.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      No trust. No depth. No resilience.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a submarine, this would get people killed. In your business, it might
      just burn you out - or hold you back.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Pick one person this quarter. Delegate real leadership, with coaching and
      feedback.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Trust isn’t taught by telling - it’s taught by handing over the wheel.
    </p>
  {/if}
</div>
